import React, {useEffect, useState} from 'react'
import Camera from "../Camera/camera";
import GoAroundApi from "../API/goAroundApi";
import styled from "styled-components";

const Message=styled.div`
    position: fixed;
    top: 3vh;
    left: 3vw;
    color:red;
    //z-index: 1000;
`

const PhotoProgressWorks = ({setSelectedGoal,house, floor}) => {
    const [image, setImage]=useState(null)
    const [isCameraOpen, setIsCameraOpen]=useState(true)
    const [showMessage, setShowMessage]=useState(false)
    const frontId=JSON.parse(localStorage.getItem("Data"))?.frontId
    useEffect(() => {
        if(!isCameraOpen){
            setSelectedGoal(null)
        }
    }, [isCameraOpen])
    useEffect(()=>{
        if(image) {
            GoAroundApi.addImage(image,house,floor,frontId)
                .then(res=>{
                    if(res.status){
                        setShowMessage(true)
                        setTimeout(_=>setShowMessage(false),3000)
                    }
                })
        }
    },[image])
// console.log(isCameraOpen)
    return (
        <div>
            {isCameraOpen?
                <Camera
                    setPicture={setImage}
                    setCameraOpen={setIsCameraOpen}
                />
                :''}
            {showMessage&&<Message>Photo was saved</Message>

            }
        </div>
    );
};

export default PhotoProgressWorks;